// @ts-nocheck
import {Component, OnDestroy, OnInit} from '@angular/core';
import {CarrierProfileService} from '../../services/carrier-profile/carrier-profile.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {StateCountry} from '../../shared/common-components/common-structure';
import {ActivatedRoute, Router} from '@angular/router';
import {AgencyProfileService} from 'src/app/services/agency-profile/agency-profile.service';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {GridOptions} from 'ag-grid-community';
import {RatesSroMasterService} from 'src/app/services/rates-sro-master/rates-sro-master.service';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import AppConstants, {BusinessType as BT, FRT_TSP_EXEMPTION_CODE as EC}  from '../../shared/common-components/AppConstants';
import {UserSelectionService} from '../../shared/user-selection/user-selection-service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import {OrganizationUpdateMessageComponent} from '../organization-update-message/organization-update-message.component';
import {NotificationPreferenceViewComponent} from '../notification-preference-view/notification-preference-view.component';
import { OrganizationUpdateMessagesService } from 'src/app/services/organization-update-messages/organization-update-messages.service';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import { TspAgyProfileAuditTrailComponent } from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import { NotificationsPreferencesService } from '../notifications-preferences/notifications-preferences.service';
import {takeWhile} from "rxjs/operators";
import {UserService} from "../../services/user/user.service";
import {User} from "../../services/user/user";
import { CarriertospecialtycodeService } from 'src/app/services/carrier-to-specialty-code/carriertospecialtycode.service';
import {
  CarriertoserviceofferingService
} from "../../services/carrier-to-service-offering/carriertoserviceoffering.service";
import {FrtAccessorialsMasterService} from "../../services/frt-accessorials-master/frt-accessorials-master.service";

@Component({
    selector: 'app-carrier-profile',
    templateUrl: './carrier-profile.component.html',
    styleUrls: ['./carrier-profile.component.css'],
    standalone: false
})
export class CarrierProfileComponent implements OnInit, OnDestroy {
  tspCategory = EC;
  tspServiceOffering ;
  showTspCategory;
  saveSuccessful: Boolean = false;
  disabled: Boolean = true;
  newProfile: Boolean = false;
  organization: any = null;
  carrierProfileForm: UntypedFormGroup;
  stateList: StateCountry[] = null;
  countryList: StateCountry[] = null;
  carrierProfileDetails: any;
  uspsData: any;
  invalidZip = false;
  deleted: Boolean = false;
  dataSourceOrigin: Observable<any>;
  secondaryDataSourceOrigin: Observable<any>;
  typeaheadOriginLoading: boolean;
  isCountrySelectedUSA: Boolean = true;
  isSecondaryCountrySelectedUSA: Boolean = true;
  stateCountry: any;
  showRfsp: any;
  bsModalRef: BsModalRef;
  reactivation: boolean = false;
  reactivate: boolean;
  reactivated: boolean;
  isFrtOnly: boolean;
  isSmartWay: boolean;
  reactivateText: any;
  minDate = new Date();
  messages: any;
  profileName: any;
  auditTrailLogList: any = [];
  samUeiDateError: Boolean = false;
  gridApi: any;
  columnDefs: any;
  localAgentsGridOptions: GridOptions;
  currentUser: User;
  permissionAccessValue: string;
  private observer$ = new BehaviorSubject(true);
  assignedTspCatList: any[] = [];
  assignedTspOfferingList: any[] = [];

  constructor(private carrierProfileService: CarrierProfileService,
              private fb: UntypedFormBuilder,
              private userService: UserService,
              private alertService: AlertService,
              private route: ActivatedRoute,
              private agencyProfileService: AgencyProfileService,
              private tmssLoader: LoadingService,
              private carrierService: CarrierService,
              private ratesSroMasterService: RatesSroMasterService,
              private organizationmessagesservice: OrganizationUpdateMessagesService,
              private shipmentAuditTrailService: ShipmentAuditTrailService,
              private stateCountryService: StateCountryService, private router: Router, private userSelectionService: UserSelectionService,
              private modalService: BsModalService,
              private notifPrefService: NotificationsPreferencesService,
              private  carriertoserviceofferingService:CarriertoserviceofferingService,
              private frtAccessorialsMasterService: FrtAccessorialsMasterService,
            private  carriertospecialtycodeService:CarriertospecialtycodeService) {
    this.dataSourceOrigin = Observable.create((observer: any) => {
      const searchText = this.carrierProfileForm?.get('asyncOriginSearchString')?.value;
      if (!searchText || !String(searchText).trim()) {
        observer.next([]);
        return;
      }
      this.ratesSroMasterService.getLocations(searchText).subscribe((result: any) => {
        const safeResults = Array.isArray(result)
          ? result.filter((item: any) => item && typeof item.cityName === 'string')
          : [];
        observer.next(safeResults);
      });
    });
    this.secondaryDataSourceOrigin = Observable.create((observer: any) => {
      const searchText = this.carrierProfileForm?.get('phAsyncOriginSearchString')?.value;
      if (!searchText || !String(searchText).trim()) {
        observer.next([]);
        return;
      }
      this.ratesSroMasterService.getLocations(searchText).subscribe((result: any) => {
        const safeResults = Array.isArray(result)
          ? result.filter((item: any) => item && typeof item.cityName === 'string')
          : [];
        observer.next(safeResults);
      });
    });
    this.localAgentsGridOptions = this.initializeGridOption();
  }

  /**
   * @description initializes formgroup with form controls.
   */
  initializeForm() {
    this.carrierProfileForm = this.fb.group({
      scac: [null, [Validators.required, Validators.maxLength(4)]],
      scacName: [null, [Validators.required, Validators.maxLength(150)]],
      dunsNumber: [null, [Validators.maxLength(9)]],
      samDbaName: [null, [Validators.maxLength(100)]],
      samEntityName: [null, [Validators.maxLength(100), Validators.required]],
      uniqueEntityId: [null, [Validators.required, Validators.maxLength(15)]],
      samUeiExpDate: [null, Validators.required],
      shipmentTrackingUrl: ['', [Validators.maxLength(500)]],
      firstName: [null, [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]],
      lastName: [null, [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]],
      middleInitial: [null, [Validators.maxLength(1)]],
      title: [null, [Validators.required, Validators.maxLength(45)]],
      secondaryContFirstName: [null, [Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]],
      secondaryContLastName: [null, [Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]],
      secondaryContMiddleInitial: [null, [Validators.maxLength(1)]],
      secondaryContTitle: [null, [Validators.maxLength(45)]],
      secondaryContPhone: new UntypedFormControl('', [Validators.minLength(10)]),
      secondaryContPhoneExt: [null, [Validators.maxLength(5)]],
      secondaryContEmail: new UntypedFormControl('', [CommonValidators.email, Validators.maxLength(45)]),
      physicalAddressLine1: [null, [Validators.maxLength(60)]],
      physicalAddressLine2: [null, [Validators.maxLength(60)]],
      phAsyncOriginSearchString: new UntypedFormControl('', []),
      physicalCity: [null, [Validators.maxLength(45)]],
      physicalState: new UntypedFormControl('', [Validators.maxLength(35)]),
      physicalStateId: new UntypedFormControl(null, []),
      physicalZip: [null, [Validators.minLength(5), Validators.maxLength(6)]],
      physicalCountry: new UntypedFormControl('326'),
      addressLine1: [null, [Validators.required, Validators.maxLength(60)]],
      addressLine2: [null, [Validators.maxLength(60)]],
      asyncOriginSearchString: new UntypedFormControl('', []),
      originCity: new UntypedFormControl(null, []),
      physicalOriginCity: new UntypedFormControl(null, []),
      city: [null, [Validators.required, Validators.maxLength(45)]],
      state: new UntypedFormControl('', [Validators.required, Validators.maxLength(35)]),
      stateId: new UntypedFormControl(null, []),
      zip: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(6)]],
      country: new UntypedFormControl('326', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
      phoneExtension: [null, [Validators.maxLength(5)]],
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email, Validators.maxLength(45)]),
      updateMessage : new UntypedFormControl('', [Validators.maxLength(250)]),
      shipmentRptContFirstName: new UntypedFormControl('', [Validators.maxLength(35)]),
      shipmentRptContLastName: [null, [Validators.maxLength(35)]],
      shipmentRptContMiddleInitial: [null, [Validators.maxLength(1)]],
      shipmentRptContEmail: new UntypedFormControl('', [CommonValidators.email, Validators.maxLength(45)]),
      shipmentRptContPhone: new UntypedFormControl('', [Validators.minLength(10)]),
      shipmentRptContPhoneExtension: [null, [Validators.maxLength(5)]],
      rfsp: [null],
      permissions: new UntypedFormControl('', [Validators.required]),
      tspCategory: new UntypedFormControl(''),
      tspServiceOffering: new UntypedFormControl(''),
      smartWayId: [false],
      assignedTspCategory: new UntypedFormControl(''),
      assignedTspOfferings: new UntypedFormControl('')
    });
  }

  categoryChange(categories: any[]) {
    console.log(categories);
    console.log(this.carrierProfileForm.value);
  }

  /**
   * @description checks for numeric values as as validator.
   */
  numericsOnly(c: UntypedFormControl) {
    const phone = /^[0-9]*$/;
    return phone.test(c.value) ? null : {
      numericsOnly: {
        valid: false
      }
    };
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch, isPrimary): void {
    if (isPrimary) {
      this.carrierProfileForm.get('originCity').setValue(e.item);
    } else {
      this.carrierProfileForm.get('physicalOriginCity').setValue(e.item);
    }
  }

  evaluatePermission(): void {
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.carrierProfileForm.get('permissions').setValue(this.currentUser?.permissions);
      this.permissionAccessValue = this.currentUser?.permissions === 'HHG' ? 'Household Goods Access' : this.currentUser?.permissions === 'FRT' ?
        'Freight Access' : 'Household Goods Access & Freight Access';
      this.showTspCategory = this.permissionAccessValue === 'Freight Access';
    });
  }

  /**
   * @description gets the list of states, countries, subscribes to query params. iniatializes the form.
   */
  ngOnInit() {
    this.isCountrySelectedUSA = true;
    this.isSecondaryCountrySelectedUSA = true;
    this.initializeForm();
    this.getStateList();
    this.getCountryList();
    this.reactivate = false;
    this.reactivated = false;
    this.showRfsp = true;
    this.carrierProfileForm.get('rfsp').setValue(false);
    this.route.queryParams.subscribe(params => {
      if (params['orgId']) {
        this.loadOrgData(params);
        this.carrierProfileForm.get('scac').disable();
        this.disabled = true;
        this.newProfile = false;
        this.carrierProfileForm.updateValueAndValidity();
      } else {
        this.disabled = false;
        this.newProfile = true;
        this.carrierProfileForm.get('updateMessage').clearValidators();
        this.carrierProfileForm.updateValueAndValidity();
        this.evaluatePermission();
      }
      if (params['status'] === 'Deleted' && !this.reactivation) {
        this.disabled = false;
        this.reactivate = true;
        this.reactivateText = 'Reactivate TSP';
      } else {
        this.reactivate = false;
        this.reactivateText = 'Deactivate TSP';
      }
    });
    this.carrierProfileForm.get('updateMessage').setValue('');
    this.carrierProfileForm.get('originCity').valueChanges.subscribe(origin => {
      this.tmssLoader.show();
      if (origin) {
        this.carrierProfileForm.get('city').setValue(origin.cityName);
        this.carrierProfileForm.get('state').setValue(origin.stateAbbrev);
        this.stateCountryService.getStateCountryByStateCountryCode(
          origin.stateAbbrev).subscribe(
          stateCountry => {
            this.stateCountry = stateCountry;
            this.carrierProfileForm.controls['stateId'].setValue(
              this.stateCountry.stateCountryId);
            this.tmssLoader.hide();
          }, (error) => {
            this.alertService.error('Error while getting origin city and state.');
            this.tmssLoader.hide();
          }
        );
        this.carrierProfileForm.get('stateId').setValue(origin.stateId);
        this.carrierProfileForm.get('zip').setValue(origin.zipCode);
      }
    });
    this.carrierProfileForm.get('physicalOriginCity').valueChanges.subscribe(secondaryOrigin => {
      this.tmssLoader.show();
      if (secondaryOrigin) {
        this.carrierProfileForm.get('physicalCity').setValue(secondaryOrigin.cityName);
        this.carrierProfileForm.get('physicalState').setValue(secondaryOrigin.stateAbbrev);
        this.stateCountryService.getStateCountryByStateCountryCode(
          secondaryOrigin.stateAbbrev).subscribe(
          stateCountry => {
            this.stateCountry = stateCountry;
            this.carrierProfileForm.controls['physicalStateId'].setValue(
              this.stateCountry.stateCountryId);
            this.tmssLoader.hide();
          }, (error) => {
            this.alertService.error('Error while getting origin city and state.');
            this.tmssLoader.hide();
          }
        );
        this.carrierProfileForm.get('physicalStateId').setValue(secondaryOrigin.stateId);
        this.carrierProfileForm.get('physicalZip').setValue(secondaryOrigin.zipCode);
      }
    });
    this.carrierProfileForm.valueChanges.subscribe(res => {
      this.saveSuccessful = false;
    });
  }

  mapPermissions(items) {
    const selectedPermissions = items.filter((item) => item.checkbox).map((item) => item.id);
    return selectedPermissions.length ? selectedPermissions : null;
  }

  /**
   * @description loads existing carrier data
   */
  loadOrgData(params) {
    this.tmssLoader.show();
    this.carrierProfileService.getOrganization(params['orgId']).subscribe(organization => {
      this.organization = organization;
      console.log(this.organization);
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving Organization');
    }, () => {
      if (this.organization.countryId == '326') {
        this.isCountrySelectedUSA = true;
      } else {
        this.isCountrySelectedUSA = false;
      }
      if (this.organization.physicalCountryId == '326') {
        this.isSecondaryCountrySelectedUSA = true;
      } else {
        this.isSecondaryCountrySelectedUSA = false;
      }
      if (AppConstants.isNotNullCondition(this.organization.carrierEntity)) {
        if(this.organization.carrierEntity.businessType === BT.FRT)
          this.lookupTspSpecialtyCodeBasedOnCarrierId(this.organization.carrierEntity.carrierId);
          this.lookupTspServiceOfferingBasedOnCarrierId(this.organization.carrierEntity.carrierId);
        this.carrierProfileForm.get('scac').setValue(this.organization.carrierEntity.scac);
        this.carrierProfileForm.get('scacName').setValue(this.organization.carrierEntity.scacName);
        this.carrierProfileForm.get('dunsNumber').setValue(this.organization.carrierEntity.dunsNumber);
        // this.carrierProfileForm.get('dunsPlus').setValue(this.organization.carrierEntity.dunsPlus);
        this.carrierProfileForm.get('uniqueEntityId').setValue(this.organization.carrierEntity.uniqueEntityIdentifier);
        this.carrierProfileForm.get('samEntityName').setValue(this.organization.carrierEntity.samEntityName);
        this.carrierProfileForm.get('samDbaName').setValue(this.organization.carrierEntity.samDbaName);
        this.carrierProfileForm.get('samUeiExpDate').setValue(new Date(this.organization.carrierEntity.samUeiExpDate));
        this.carrierProfileForm.get('shipmentTrackingUrl').setValue(this.organization.carrierEntity.shipmentTrackingUrl || '');
        if (this.organization.carrierEntity.smartWayId === 1) {
          this.carrierProfileForm.get('smartWayId').setValue(true);
          this.isSmartWay = true;
        } else {
          this.carrierProfileForm.get('smartWayId').setValue(false);
          this.isSmartWay = false;
        }

        this.carrierProfileForm.get('shipmentRptContFirstName').setValue(this.organization.carrierEntity.shipmentRptContFirstName);
        this.carrierProfileForm.get('shipmentRptContLastName').setValue(this.organization.carrierEntity.shipmentRptContLastName);
        this.carrierProfileForm.get('shipmentRptContMiddleInitial').setValue(this.organization.carrierEntity.shipmentRptContMiddleInitial);
        this.carrierProfileForm.get('shipmentRptContEmail').setValue(this.organization.carrierEntity.shipmentRptContEmail);
        this.carrierProfileForm.get('shipmentRptContPhone').setValue(this.organization.carrierEntity.shipmentRptContPhone);
        this.carrierProfileForm.get('shipmentRptContPhoneExtension').setValue(this.organization.carrierEntity.shipmentRptContPhoneExtension);
        this.carrierProfileForm.get('secondaryContFirstName').setValue(this.organization.carrierEntity.secondaryContFirstName);
        this.carrierProfileForm.get('secondaryContLastName').setValue(this.organization.carrierEntity.secondaryContLastName);
        this.carrierProfileForm.get('secondaryContMiddleInitial').setValue(this.organization.carrierEntity.secondaryContMiddleInitial);
        this.carrierProfileForm.get('secondaryContTitle').setValue(this.organization.carrierEntity.secondaryContTitle);
        this.carrierProfileForm.get('secondaryContEmail').setValue(this.organization.carrierEntity.secondaryContEmail);
        this.carrierProfileForm.get('secondaryContPhone').setValue(this.organization.carrierEntity.secondaryContPhone);
        this.carrierProfileForm.get('secondaryContPhoneExt').setValue(this.organization.carrierEntity.secondaryContPhoneExt);

        if (this.organization.carrierEntity.carrierType === 'RFSP') {
          this.carrierProfileForm.get('rfsp').setValue(true);
        } else {
          this.carrierProfileForm.get('rfsp').setValue(false);
        }
      }
      this.carrierProfileForm.get('firstName').setValue(this.organization.firstName);
      this.carrierProfileForm.get('lastName').setValue(this.organization.lastName);
      this.carrierProfileForm.get('middleInitial').setValue(this.organization.middleInitial);
      this.carrierProfileForm.get('title').setValue(this.organization.title);
      this.carrierProfileForm.get('addressLine1').setValue(this.organization.addressLine1);
      this.carrierProfileForm.get('addressLine2').setValue(this.organization.addressLine2);
      this.carrierProfileForm.get('city').setValue(this.organization.city);
      this.agencyProfileService.getCityState(this.organization.zip)
        .subscribe(uspsDetails => {
            this.carrierProfileForm.controls['state'].setValue(uspsDetails.stateAbbrev);
          }, (error) => {
            this.alertService.error('');
            this.tmssLoader.hide();
          }
        );
      this.carrierProfileForm.get('zip').setValue(this.organization.zip);
      this.carrierProfileForm.get('country').setValue(this.organization.countryId);
      if (this.carrierProfileForm.get('country').value !== '326') {
        this.carrierProfileForm.get('zip').clearValidators();
        this.carrierProfileForm.get('state').clearValidators();
        this.carrierProfileForm.get('city').clearValidators();
        this.carrierProfileForm.get('zip').setErrors(null);
        this.carrierProfileForm.get('state').setErrors(null);
        this.carrierProfileForm.get('city').setErrors(null);
      }

      this.carrierProfileForm.get('physicalAddressLine1').setValue(this.organization.physicalAddressLine1);
      this.carrierProfileForm.get('physicalAddressLine2').setValue(this.organization.physicalAddressLine2);
      this.carrierProfileForm.get('physicalCity').setValue(this.organization.physicalCity);
      if (this.organization.physicalZip) {
        this.agencyProfileService.getCityState(this.organization.physicalZip)
          .subscribe(uspsDetails => {
              this.carrierProfileForm.controls['physicalState'].setValue(uspsDetails.stateAbbrev);
            }, (error) => {
              this.alertService.error('');
              this.tmssLoader.hide();
            }
          );
      }
      this.carrierProfileForm.get('physicalZip').setValue(this.organization.physicalZip);
      this.carrierProfileForm.get('physicalCountry').setValue(this.organization.physicalCountryId);
      this.carrierProfileForm.get('phone').setValue(this.organization.phone);
      this.carrierProfileForm.get('phoneExtension').setValue(this.organization.phoneExtension);
      this.carrierProfileForm.get('email').setValue(this.organization.email);
      this.carrierProfileForm.get('permissions').setValue(this.organization.permission);
      this.permissionAccessValue = this.organization.permission === 'HHG' ? 'Household Goods Access' : this.organization.permission === 'FRT' ?
        'Freight Access' : 'Household Goods Access & Freight Access';
      this.showTspCategory = this.permissionAccessValue === 'Freight Access';
      this.carrierProfileForm.get('updateMessage').setValue(this.organization.updateMessage);
      if (this.organization.permission === 'FRT') {
        this.isFrtOnly = true;
      } else {
        this.isFrtOnly = false;
      }
      this.validateErrors();
      this.findInvalidControls();
      this.tmssLoader.hide();
    });
  }

  /**
   * @description saves the carrier profile.
   */
  saveOrganization() {
    const carrierProfileForm1 = this.carrierProfileForm.getRawValue();
    if (AppConstants.isNotNullCondition(this.organization)) {
      this.userSelectionService.checkUserIsAdminWithEmailAndOrgId(carrierProfileForm1.email, this.organization.organizationId).subscribe(exist => {
        if (exist === true) {
          this.callCreateProfile('updated');
        } else {
          this.alertService.information('Contact Information email entered does not meet the admin criteria, email must be registered in the system as a group admin for this organization.');
        }
      }, error => {
        this.tmssLoader.hide();
        this.alertService.error('Error in while evaluating  email ' + error);
      });
    } else {
      this.callCreateProfile('created');
    }
  }

  reactivate1() {
    this.callCreateProfile('reactivate');
  }

  changeTimeZone(date) {
    if (date) {
      const estDateTime = new Date(date.toLocaleString('en-US', {timeZone: 'America/New_York'}));
      const year = estDateTime.getFullYear();
      const month = estDateTime.getMonth() + 1;
      const day = estDateTime.getDate();
      return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
    }
    return null;
  }

  assignTime(date) {
    if (date) {
      const estDateTime = new Date(date.toLocaleString('en-US', {timeZone: 'America/New_York'}));
      estDateTime.setHours(17,59,59);
      return estDateTime;
    }
    return null;
  }

  callCreateProfile(from?) {
    const carrierProfileForm1 = this.carrierProfileForm.getRawValue();
    if (this.organization == null) {
      this.organization = {};
      this.organization.carrierEntity = {};
    }
    this.organization.carrierEntity.scac = carrierProfileForm1.scac;
    this.organization.carrierEntity.scacName = carrierProfileForm1.scacName;
    this.organization.carrierEntity.dunsNumber = carrierProfileForm1.dunsNumber;
    // this.organization.carrierEntity.dunsPlus = carrierProfileForm1.dunsPlus;
    this.organization.carrierEntity.uniqueEntityIdentifier = carrierProfileForm1.uniqueEntityId;
    if (carrierProfileForm1.smartWayId === true) {
      this.organization.carrierEntity.smartWayId = 1;
    } else {
      this.organization.carrierEntity.smartWayId = 0;
    }
    this.organization.firstName = carrierProfileForm1.firstName;
    this.organization.lastName = carrierProfileForm1.lastName;
    this.organization.middleInitial = carrierProfileForm1.middleInitial;
    this.organization.title = carrierProfileForm1.title;
    this.organization.addressLine1 = carrierProfileForm1.addressLine1;
    this.organization.addressLine2 = carrierProfileForm1.addressLine2;
    this.organization.city = carrierProfileForm1.city;
    this.organization.stateId = carrierProfileForm1.stateId;
    this.organization.stateName = carrierProfileForm1.state;
    this.organization.zip = carrierProfileForm1.zip;
    this.organization.countryId = carrierProfileForm1.country;
    this.organization.phone = carrierProfileForm1.phone;
    this.organization.phoneExtension = carrierProfileForm1.phoneExtension;
    this.organization.email = carrierProfileForm1.email.trim();
    this.organization.updateMessage = (AppConstants.isNotNullCondition(carrierProfileForm1.updateMessage))? carrierProfileForm1.updateMessage.trim(): '';
    this.organization.tspCategory = carrierProfileForm1.tspCategory || [];
    this.organization.tspServiceOffering = this.assignedTspOfferingList ? this.assignedTspOfferingList.map(item => item.frtTspServiceOfferingsId) : [];

    this.organization.physicalAddressLine1 = carrierProfileForm1.physicalAddressLine1;
    this.organization.physicalAddressLine2 = carrierProfileForm1.physicalAddressLine2;
    this.organization.physicalCity = carrierProfileForm1.physicalCity;
    this.organization.physicalStateId = carrierProfileForm1.physicalStateId;
    this.organization.stateName = carrierProfileForm1.state;
    this.organization.physicalZip = carrierProfileForm1.physicalZip;
    this.organization.physicalCountryId = carrierProfileForm1.physicalCountry;
    this.organization.carrierEntity.samEntityName = carrierProfileForm1.samEntityName;
    this.organization.carrierEntity.samDbaName = carrierProfileForm1.samDbaName;
    this.organization.carrierEntity.samUeiExpDate = this.assignTime(carrierProfileForm1.samUeiExpDate);
    this.organization.carrierEntity.shipmentTrackingUrl = carrierProfileForm1.shipmentTrackingUrl ? String(carrierProfileForm1.shipmentTrackingUrl).trim() : '';
    //this.organization.carrierEntity.samUeiExpDate = carrierProfileForm1.samUeiExpDate;
    this.organization.carrierEntity.secondaryContFirstName = carrierProfileForm1.secondaryContFirstName;
    this.organization.carrierEntity.secondaryContLastName = carrierProfileForm1.secondaryContLastName;
    this.organization.carrierEntity.secondaryContMiddleInitial = carrierProfileForm1.secondaryContMiddleInitial;
    this.organization.carrierEntity.secondaryContTitle = carrierProfileForm1.secondaryContTitle;
    this.organization.carrierEntity.secondaryContEmail = carrierProfileForm1.secondaryContEmail;
    this.organization.carrierEntity.secondaryContPhone = carrierProfileForm1.secondaryContPhone;
    this.organization.carrierEntity.secondaryContPhoneExt = carrierProfileForm1.secondaryContPhoneExt;
    this.organization.carrierEntity.shipmentRptContFirstName = carrierProfileForm1.shipmentRptContFirstName;
    this.organization.carrierEntity.shipmentRptContLastName = carrierProfileForm1.shipmentRptContLastName;
    this.organization.carrierEntity.shipmentRptContMiddleInitial = carrierProfileForm1.shipmentRptContMiddleInitial;
    this.organization.carrierEntity.shipmentRptContEmail = carrierProfileForm1.shipmentRptContEmail ? carrierProfileForm1.shipmentRptContEmail.trim() : '';
    this.organization.carrierEntity.shipmentRptContPhone = carrierProfileForm1.shipmentRptContPhone;
    this.organization.carrierEntity.shipmentRptContPhoneExtension = carrierProfileForm1.shipmentRptContPhoneExtension;
    this.organization.carrierEntity.shipmentRptContPhoneExtension = carrierProfileForm1.shipmentRptContPhoneExtension;
    this.organization.permission = carrierProfileForm1.permissions;
    // setting permissions
    if (this.organization.permission === 'HHG' && carrierProfileForm1.rfsp === true) {
      this.organization.carrierEntity.carrierType = 'RFSP';
    } else {
      this.organization.carrierEntity.carrierType = 'CARRIER';
    }
    if (!this.reactivate) { // Save Carrier Profile
      this.tmssLoader.show();
      this.saveFRTTSPSpecialtyCode();
      this.carrierProfileService.saveOrganization(this.organization).subscribe(organization => {
          this.organization = organization;
          this.alertService.success('Successfully ' + from + ' the profile');
          this.saveSuccessful = true;
          // this.disabled = true;
          this.tmssLoader.hide();
        },
        error => {
          this.tmssLoader.hide();
          this.alertService.error('Error in saving profile ' + error.error);
        });
    } else { // Reactivate TSP
      this.reactivateTsp();
    }
  }

  samDateChange($event): void {
    this.samUeiDateError = $event < this.minDate;
  }

  // to deactivate a TSP
  deleteOrgData() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.body = `If this action is taken, a TSP would be:
    <ul>
        <li>“Revoked” for all approval types it is approved for – Domestic, International, and/or XTOS.</li>
        <li>All users would be deleted from the system.</li>
        <li>All scope would be deleted from the system.</li>
        <li>Past rate history would be maintained per Audit rules.</li>
    </ul>`;
    this.bsModalRef.content.title = 'TSP Revocation';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show(); // deleteOrganization
        const deleteCarrierMappingEntity: any = {
          'orgId': this.organization.organizationId,
          'message': this.carrierProfileForm.get('updateMessage').value
        };
        this.carrierProfileService.deleteOrganizationWithMessage(deleteCarrierMappingEntity).subscribe(deleted => {
          this.deleted = deleted;
          this.alertService.success('Successfully Revoked the selected TSP');
          // agencyCode + '' + bureauCode + '-' + agencyBureauName + '<br />' + ' Location: ' + city + '-' + stateCountryCode
          this.router.navigate(['/agencytspsearch']);
          this.tmssLoader.hide();
        });
      }
    }, () => {
      this.alertService.warn('Accepting carry forward has been cancelled.');
    });
  }

  /*  deleteTsp(){
      if (this.organization.carrierEntity.carrierId !== null) {
        // User clicked Delete from the TSP User List
        this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
        this.bsModalRef.content.question = 'Are you sure, you want to delete this TSP? This process will delete the TSP permanently, so consider your choice carefully. Please Click "OK" to continue with Deletion, or "Cancel" to go back ';
        this.bsModalRef.content.title = 'USER DELETE';
        this.bsModalRef.content.confirmText = 'Ok';
        this.bsModalRef.content.cancelText = 'Cancel';
        this.bsModalRef.content.emitData.subscribe(result => {
          if (result.obj === true) {
            this.tmssLoader.show();
            this.carrierService.deleteCarrierUser(this.organization.carrierEntity.carrierId).subscribe(response => {
              this.tmssLoader.hide();
              this.alertService.info(response.response);
              this.router.navigate(['/agencytspsearch']);
            }, error => {
              this.tmssLoader.hide();
              console.log('There was an error deleting carrier');
              this.alertService.error('There was an error deleting carrier: ' + error);
            });
          }
        });
      }
    }*/

// Reactivate TSP
  reactivateTsp() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to reactivate a TSP in TMSS 2.0. Please Click "OK" to continue with Reactivation, or "Cancel" to go back';
    this.bsModalRef.content.title = 'TSP Reactivation';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.carrierProfileService.reactivateTsp(this.organization).subscribe(organization => {
            this.organization = organization;
            this.alertService.success('Successfully Reactivated the TSP');
            // this.saveSuccessful = true;
            // this.router.navigate(['/agencytspsearch']);
            this.reactivation = true;
            this.disabled = true;
            this.reactivate = false;
            this.reactivated = true;
            this.tmssLoader.hide();
          },
          error => {
            this.tmssLoader.hide();
            this.alertService.error('Error in saving profile ' + error.error);
          });
      }
    }, () => {
      this.alertService.warn('Reactivating TSP has been cancelled.');
    });
  }

  /**
   * @description to get all states list
   */
  getStateList() {
    this.tmssLoader.show();
    this.carrierProfileService.getAllStates('State').subscribe(
      states => {
        this.stateList = states;
        this.tmssLoader.hide();
        return this.stateList;
      }, (error) => {
        this.alertService.error('Error while getting states list.');
        this.tmssLoader.hide();
      });
  }

  /**
   * @description to change states from the list
   */
  changeState($event) {
    return this.carrierProfileForm.get('state').value;

  }

  /**
   * @description To get all countries list
   */
  getCountryList() {
    this.tmssLoader.show();
    const countryList = [];
    this.carrierProfileService.getAllStates('Country').subscribe(
      countries => {
        this.countryList = countries;
        this.countryList = CommonValidators.promote(this.countryList);
        this.tmssLoader.hide();
        this.findInvalidControls();
        return this.countryList;
      }, (error) => {
        this.alertService.error('Error while getting countries list.');
        this.tmssLoader.hide();
      });

  }


  /**
   * @description listens to coutnry changes and enables/disables, sets/clears errors setvalues to null for form controls city, state, zip
   */
  /**
   * @description listens to sountry changes and enables/disabels the controls.
   */
  onCountryChange() {
    this.carrierProfileForm.get('zip').setValue(null);
    this.carrierProfileForm.get('state').setValue(null);
    this.carrierProfileForm.get('city').setValue(null);
    const country = this.carrierProfileForm.get('country').value;
    if (country !== '326') {
      this.isCountrySelectedUSA = false;
      this.carrierProfileForm.get('zip').clearValidators();
      this.carrierProfileForm.get('state').clearValidators();
      this.carrierProfileForm.get('city').clearValidators();
      this.carrierProfileForm.get('zip').setErrors(null);
      this.carrierProfileForm.get('state').setErrors(null);
      this.carrierProfileForm.get('city').setErrors(null);
    } else {
      this.isCountrySelectedUSA = true;
      this.carrierProfileForm.get('state').enable();
      this.carrierProfileForm.get('zip').enable();
      this.carrierProfileForm.get('state').setValidators([Validators.required]);
      this.carrierProfileForm.get('zip').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(6)]);
    }
  }

  onSecondaryCountryChange() {
    this.carrierProfileForm.get('physicalZip').setValue(null);
    this.carrierProfileForm.get('physicalState').setValue(null);
    this.carrierProfileForm.get('physicalCity').setValue(null);
    const country = this.carrierProfileForm.get('physicalCountry').value;
    if (country !== '326') {
      this.isSecondaryCountrySelectedUSA = false;
      this.carrierProfileForm.get('physicalZip').clearValidators();
      this.carrierProfileForm.get('physicalState').clearValidators();
      this.carrierProfileForm.get('physicalCity').clearValidators();
      this.carrierProfileForm.get('physicalZip').setErrors(null);
      this.carrierProfileForm.get('physicalState').setErrors(null);
      this.carrierProfileForm.get('physicalCity').setErrors(null);
    } else {
      this.isSecondaryCountrySelectedUSA = true;
      this.carrierProfileForm.get('physicalState').enable();
      this.carrierProfileForm.get('physicalZip').enable();
      this.carrierProfileForm.get('physicalState').setValidators([Validators.required]);
      this.carrierProfileForm.get('physicalZip').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(6)]);
    }
  }

  /**
   * @description clears values for formcontrols zip, city, state
   */
  clearValues() {
    this.carrierProfileForm.get('state').setValue(null);
    this.carrierProfileForm.get('zip').setValue(null);
    this.carrierProfileForm.get('city').setValue(null);
  }

  /**
   * @description clear errors for formcontrols zip, city, state
   */
  clearErrors() {
    this.carrierProfileForm.get('state').setErrors(null);
    this.carrierProfileForm.get('zip').setErrors(null);
    this.carrierProfileForm.get('city').setErrors(null);
  }

  /**
   * @description finds invalid controls
   */
  public findInvalidControls() {
    const invalid = [];
    this.validateErrors();
    const controls = this.carrierProfileForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  /**
   * @description clears erros for the below form controls
   */
  validateErrors() {
    if (this.carrierProfileDetails != null) {
      this.carrierProfileForm.controls.emailCheck.setErrors(null);
      this.carrierProfileForm.controls.firstName.setErrors(null);
      this.carrierProfileForm.controls.lastName.setErrors(null);
      this.carrierProfileForm.controls.title.setErrors(null);
      this.carrierProfileForm.controls.phone.setErrors(null);
      this.carrierProfileForm.controls.addressLine1.setErrors(null);
      this.carrierProfileForm.controls.city.setErrors(null);
      this.carrierProfileForm.controls.state.setErrors(null);
      this.carrierProfileForm.controls.zip.setErrors(null);
      this.carrierProfileForm.controls.country.setErrors(null);
    }
  }

  /**
   * @description Zipcode search populates city and state
   */
  getCityState() {
    const zipCodeValue = this.carrierProfileForm.controls['zip'].value;
    if (zipCodeValue !== '') {
      this.tmssLoader.show();
      this.agencyProfileService.getCityState(this.carrierProfileForm.controls['zip'].value)
        .subscribe(uspsDetails => {
            this.tmssLoader.hide();
            this.uspsData = uspsDetails;
            this.carrierProfileForm.controls['city'].setValue(uspsDetails.cityName);
            this.carrierProfileForm.controls['state'].setValue(uspsDetails.stateId);
            this.carrierProfileForm.controls['country'].setValue('326');
            this.invalidZip = uspsDetails.zipCodeValue == null;
          }, error => {
            this.tmssLoader.hide();
            this.alertService.error('Error while getting city and state.');
          }
        );
      return this.uspsData;
    }
  }

  /**
   * @description programatical navigation to go to carrier approval screen.
   */
  goToApprovalInformation() {
    this.router.navigate(['/carrierapproval'],
      {queryParams: {carrierId: [this.organization.carrierEntity.carrierId]}});
  }

  /**
   * @description programatical navigation to go to carrier approval screen.
   */
  gotToAgencyUser() {
    this.router.navigate(['/agencyuser'],
      {queryParams: {organizationId: [this.organization!.organizationId!], isAgencyUser: [false]}});
  }

  /**
   * @description programatical navigation to go to carrier contact info screen.
   */
  gotoCarrierContactInfo() {
    this.router.navigate(['/carriercontact'],
      {
        queryParams: {
          organizationId: [this.organization.organizationId],
          carrierId: [this.organization.carrierEntity.carrierId],
          businessType: [this.organization.carrierEntity.businessType],
          scac: [this.organization.carrierEntity.scac]
        }
      });
  }

  /**
   * @description programatical navigation to go to carrier contact info screen.
   */
  gotoNotificationsPrefs() {
    this.router.navigate(['/notificationspreferences'],
      {
        queryParams: {
          organizationId: [this.organization.organizationId],
          carrierId: [this.organization.carrierEntity.carrierId],
          businessType: [this.organization.carrierEntity.businessType],
          scac: [this.organization.carrierEntity.scac],
          name: [this.organization.carrierEntity.scacName],
          permissions: [this.organization.carrierEntity.businessType],
          role: ['sysAdmin'],
          comingFrom: ['carrierProfile']
        }
      });
  }


  /**
   *  validating for testing purpose only it will return invalid fields
   */
  validateForm() {
    AppConstants.getFormValidationErrors(this.carrierProfileForm);
  }

  messageHistoryModal() {
    this.tmssLoader.show();
    this.profileName = this.organization.carrierEntity.scac + ' - ' + this.organization.carrierEntity.scacName;
    this.organizationmessagesservice.getMessages(this.organization.organizationId).subscribe(messages => {
      this.messages = messages;
      if (this.messages.length > 0){
        const initialState = {
          //orgId: this.organization.organizationId
          messages: this.messages,
          profile: this.profileName,
          header: 'Profile Update Notes History'
        };
        this.bsModalRef = this.modalService.show(OrganizationUpdateMessageComponent, { initialState, backdrop: 'static', class: 'modal-lg' });
      } else {
        this.alertService.error('No messages/notes history to display.');
      }

      this.tmssLoader.hide();
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('Unable to load the message history.. Please try again later or contact system administrator');
    });

  }

  /**
   * @description Navigates to Audit Trial
   */
  viewAuditTrial() {
    this.tmssLoader.show();
    this.profileName = this.organization.carrierEntity.scac + ' - ' + this.organization.carrierEntity.scacName;
    this.shipmentAuditTrailService.getAuditTrailListByOrgId(this.organization.organizationId).subscribe(data => {
      //      console.log('auditTrailLogList data: ' + data);
      if (data) {

        this.auditTrailLogList = data;
        console.log('Successfully retrieved audit records And auditTrailLogList length: ' + this.auditTrailLogList.length);
        const initialState: any = {
          //orgId: this.organization.organizationId
          auditTrailLogList: this.auditTrailLogList,
          profile: this.profileName
        };
        this.bsModalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });

      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.tmssLoader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  initializeGridOption(){
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 25,
      headerHeight: 50,
      domLayout: 'autoHeight',
      suppressDragLeaveHidesColumns: true,

      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Select the notification type to load report.</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  onNotificationPreference(){
    this.tmssLoader.show();
    this.notifPrefService.getNotifPrefByBusinessTypeAndOrgId(this.organization.carrierEntity.businessType, Number(this.organization.carrierEntity.organizationId)).subscribe(
      (data: any) => {
        const initialState: any = {
          notificationPreferences: data,
          profile: null
        };
        this.bsModalRef = this.modalService.show(NotificationPreferenceViewComponent, { initialState, backdrop: 'static', class: 'modal-lg' });
        console.log(data);
      }, (error : any) => {
        this.tmssLoader.hide();
        this.alertService.error('Unable to load the Notification Preferences.. Please try again later or contact system administrator');
      }
    );
  }

  onChangeCheckSCAC(){
    let scac = this.carrierProfileForm.get('scac').value;
    this.tmssLoader.show()
    this.carrierProfileService.checkExistingScac(scac,this.currentUser.permissions ).subscribe(carrier => {
      this.tmssLoader.hide();
        if (carrier != null) {
          this.alertService.error('The SCAC code entered already exists in the system. Please go back to User Administration and search the SCAC code. You can reinstae the SCAC if revoked else make appropriate modifications.');
        }
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while checking SCAC code');
      });

  }

  moveItems(sourceArray: any) {
    const assignTspCat: any[] = [];
    const destinationArray = this.assignedTspCatList;
    this.tspCategory.forEach(e => {
      sourceArray.forEach((y: any) => {
        if (e.value === y) {
          assignTspCat.push(e);
        }
      });
    });
    this.assignedTspCatList = Array.from(new Set(destinationArray.concat(assignTspCat)));
  }

  moveOfferings(sourceArray: any) {
    const assignServiceOfferings: any[] = [];
    const destinationArray = this.assignedTspOfferingList;
    this.tspServiceOffering.forEach(e => {
      sourceArray.forEach((y: any) => {
        if (e.frtTspServiceOfferingsId === y) {
          assignServiceOfferings.push(e);
        }
      });
    });
    this.assignedTspOfferingList = Array.from(new Set(destinationArray.concat(assignServiceOfferings)));
  }

  handleAccMultiDropdown(i: any) {
      this.assignedTspCatList.splice(i, 1);
  }

  handleOfferingsMultiDropdown(i: any) {
    this.assignedTspOfferingList.splice(i, 1);
  }

  lookupTspSpecialtyCodeBasedOnCarrierId(carrierId: Number){
    this.carriertospecialtycodeService.getSpecialtyCodeBasedOnCarrierID(carrierId).subscribe({
      next: (response:any) => {
        response.forEach((e:any) => {
          this.tspCategory.forEach(constItem => {
            if(constItem.code === e.tspSpecialtyCodesId)
              this.assignedTspCatList.push(constItem);
          })
        });
      },
      error: (error:any) => {
        console.error('Error fetching data', error);
      },
      complete: () => {
        console.log('Data fetch completed');
      }
    }
    )
  }

  lookupTspServiceOfferingBasedOnCarrierId(carrierId: Number){
    this.frtAccessorialsMasterService.getFrtServiceOfferings().subscribe(offerings => {
      this.tspServiceOffering = offerings;
      this.carriertoserviceofferingService.getServiceOfferingOnCarrierID(carrierId).subscribe({
          next: (response:any) => {
            response.forEach((e:any) => {
              this.tspServiceOffering.forEach(constItem => {
                if(constItem.frtTspServiceOfferingsId === e.frtTspServiceOfferingsId)
                  this.assignedTspOfferingList.push(constItem);
              })
            });
          },
          error: (error:any) => {
            console.error('Error fetching data', error);
          },
          complete: () => {
            console.log('Data fetch completed');
          }
        }
      )
    }, error => {
      this.alertService.error('Error while getting offerings');
    });
  }

  saveFRTTSPSpecialtyCode(){
    if(this.organization.carrierEntity.businessType === BT.HHG || !AppConstants.isNotNullCondition(this.assignedTspCatList)) return;
    let tspSpecCode = [];
    this.assignedTspCatList.forEach(e => {tspSpecCode.push(e.value);});
    this.organization.tspCategory = tspSpecCode;
    console.log(tspSpecCode);
  }

  saveFRTTSPServiceOfferings(){
    if(this.organization.carrierEntity.businessType === BT.HHG || !AppConstants.isNotNullCondition(this.assignedTspCatList)) return;
    let tspSpecCode = [];
    this.assignedTspOfferingList.forEach(e => {tspSpecCode.push(e.value);});
    this.organization.tspCategory = tspSpecCode;
    console.log(tspSpecCode);
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }
}
